<template>
  <div class="public_benefit_header">
    <div class="header_benefit">
      <div class="logo_block">
        <div class="logo"></div>
        <div class="title">全国足球特色幼儿园系统平台</div>
      </div>
      <div class="prefootball">-PREFOOTBALL-</div>
      <div class="content">
        <div class="title_content">
          <span></span>
          <div class="text">中国足球发展基金会幼儿足球教育公益项目</div>
          <span></span>
        </div>
        <div class="title_top">希望孩子通过足球运动和游戏享受乐趣，开启全人格教育新起点</div>
      </div>
    </div>
    
  </div>
</template>

<script>
  export default {
    name: 'publicBenefitHeader',
    components: {
      // titleComponent,
    },
    methods: {},
  }
</script>

<style lang="scss" scoped>
  .public_benefit_header {
    .center_block {
      display: block;
      width: 1440px !important;
      margin: 0 auto 150px;
    }

    .header_benefit {
      width: 100%;
      height: 495px;
      box-sizing: border-box;
      padding-top: 59px;
      background-position: center;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-image: url('../assets/img/publicBenefit/other_banner.png');
    }

    .header_benefit .logo_block {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .header_benefit .logo {
      width: 137px;
      height: 137px;
      margin-right: 17px;
      background-position: center;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-image: url('../assets/img/publicBenefit/logo.png');
    }

    .header_benefit .title {
      font-size: 75px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #FFFFFF;
    }

    .prefootball {
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
    }

    .header_benefit .content {
      margin-top: -125px;
      width: 100%;
      height: 366px;
      display: flex;
      flex-direction: column;
      text-align: center;
      justify-content: center;
      align-items: center;
    }

    .header_benefit .content .title_top {
      font-size: 32px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #FFFFFF;
    }

    .header_benefit .content .title_content {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 870px;
      height: 54px;
      background: #FFFFFF;
      border-radius: 23px;
      margin-bottom: 25px;
      margin-top: 41px;
    }

    .header_benefit .content .title_content .text {
      font-size: 35px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #BB2528;
      letter-spacing: 2px;
      margin: 0 30px 0 26px;
    }

    .header_benefit .content .title_content span {
      width: 28px;
      height: 27px;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(data:image/png;base64,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);
    }

    
  }
</style>